import { JSX } from 'react'
import { observer } from 'mobx-react-lite'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

import { BrandIcon } from '@authy/lib-client/assets'
import { env } from '@authy/lib-client/env'
import { Link } from '@authy/lib-web/components'

import { adminAppState } from '@/appState'

type MobileNavigationProps = {
    open: boolean
    onToggleOpen: (open: boolean) => void
}

export const MobileHeader = observer(({ open, onToggleOpen }: MobileNavigationProps): JSX.Element => {
    const { tenant } = adminAppState

    const appUrl = env.VITE_PRODUCT_URL_ROOT
    const appUrlTenant = `${appUrl}/${tenant?._id.toString() || ''}`

    return (
        <div className="px-page z-10 shrink-0 grow-0 bg-white md:hidden dark:bg-neutral-700">
            <div className="flex h-14 items-center justify-between">
                <div className="flex items-center">
                    <div className="shrink-0">
                        <Link href={appUrlTenant}>
                            <BrandIcon className="size-8" />
                        </Link>
                    </div>
                </div>
                <div>
                    <div className="ml-4 flex items-center font-medium md:ml-6">{env.VITE_PRODUCT_NAME}</div>
                </div>
                <div>
                    <div
                        className="relative inline-flex items-center justify-center rounded-md bg-neutral-200 p-2 active:bg-neutral-300 dark:bg-neutral-800 dark:active:bg-neutral-900"
                        onClick={() => onToggleOpen(!open)}
                    >
                        <span className="absolute -inset-0.5" />
                        {open ? (
                            <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                        ) : (
                            <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
})
